import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import classes from './RizaResponses.module.css';
import RizaLogo from 'assets/images/riza-logo-icon-simple.png';
import { rizaResponsesList } from 'shared/utility';

class RizaResponses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeResponse: null,
    };
  }

  handleResponseHover = (response) => {
    let activeResponse = null;
    if (this.state.activeResponse !== response) {
      activeResponse = response;
    }
    this.setState({ activeResponse });
  };

  render = () => {
    return (
      <div className={classes.RizaResponsesContainer}>
        <div className={classes.RizaResponsesHeader}>
          <img src={RizaLogo} alt="riza " />
          <h2>Riza Responses</h2>
        </div>
        {rizaResponsesList.map((response) => {
          const responseClasses = [classes.ResponseClasses];
          if (this.state.activeResponse === response) responseClasses.push(classes.Hover);
          return (
            <div
              className={responseClasses.join(' ')}
              key={response}
              onMouseEnter={() => this.handleResponseHover(response)}
              onMouseLeave={() => this.handleResponseHover(response)}
            >
              <p onClick={() => this.props.addResponse(response)}>{response}</p>
              <FontAwesomeIcon icon="pencil-alt" className={classes.PencilIcon} />
            </div>
          );
        })}
      </div>
    );
  };
}

export default RizaResponses;
